<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>资源管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <el-tabs v-model="activeName">
        <template v-for="(item, index) in resources">
          <el-tab-pane :label="item.name" :name="item.key">
            <rselect
              :options="item.options.options"
              :value="item.selected"
              :rkey="item.key"
              @saveCallback="saveCallback($event, index)"
            ></rselect>
          </el-tab-pane>
        </template>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { resourceList } from '@/service/getData'
import { isMobile } from '@/util/index'
import Rselect from '@/views/resource/selector'
import store from '@/store/store'

export default {
  components: {
    Rselect,
  },
  data() {
    return {
      activeName: '',
      isMobile,
      resources: [],
      isadealer: store.getters.userInfo.dealer_id > 0,
    }
  },
  created() {
    this.getResources()
  },
  methods: {
    async getResources() {
      let res = await resourceList()
      let filterPlatform = this.isadealer ? 1 : 2
      if (res.code == 0) {
        this.resources = res.data.list
          .filter((it) => it.platform != filterPlatform)
          .map((item) => {
            if (item.items) {
              item.selected = item.items.map((i) => {
                return parseInt(i.value)
              })
            } else {
              item.selected = []
            }
            return item
          })
        if (this.resources.length > 0) {
          this.activeName = this.resources[0].key
        }
      }
    },
    saveCallback(e, index) {
      this.resources[index].selected = e
    },
  },
}
</script>

<style scoped>
.long {
  width: 100%;
}
/deep/.el-checkbox {
  width: 120px;
  margin-top: 5px;
}
</style>